import React, { ReactNode } from 'react'
import bottomElement from 'assets/investors/bottom-element.png'
import EsgProfileEmbed from './EsgProfileEmbed'

export default function ESGUpdates({
  current,
  view,
}: {
  view?: ReactNode
  current?: string
}) {
  return (
    <div className="relative bg-cream3 bg-no-repeat pb-16 pt-4 md:pb-20 md:pt-6">
      <div className="relative z-10 mx-auto w-full max-w-none px-4 sm:px-6 lg:px-8 2xl:px-12">
        <EsgProfileEmbed />
      </div>

      <div className="absolute bottom-16 -z-[0] md:bottom-20">
        <img src={bottomElement} alt="" className="w-full" />
      </div>
    </div>
  )
}